import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupLicenseComponent } from './setup-license.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CreditAmountModalComponent } from './credit-amount-modal/credit-amount-modal.component';

@NgModule({
	declarations: [SetupLicenseComponent, CreditAmountModalComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, ModalModule.forRoot()],
	exports: [SetupLicenseComponent],
	providers: [],
})
export class SetupLicenseModule {}
